import { z } from "zod";

const invalidDomains = ["gmail.cz", "seznam.com"];

const isKnownDomain = (value: string) => {
  return !invalidDomains.some((invalidDomain) => value.includes(invalidDomain));
};

export const customEmailSchema = z
  .string()
  .min(1, "Zadejte email")
  .email("Email je neplatný. Zkontrolujte, zda jste nenapsali překlep")
  .refine(isKnownDomain, (val) => ({
    message: `${val.split("@")[1]} není správná koncovka emailu.`,
  }));
